export default async function useBrandUrls(manufacturerIds) {
    const config = useRuntimeConfig();
    const BASE_URL = config.public.shopwareEndpoint + 'brandUrls';
    const sw_access_key = config.public.shopwareToken; // Replace with your actual access token

    try {
        const response = await fetch(BASE_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'sw-access-key': sw_access_key,
            },
            body: JSON.stringify({
                brands: manufacturerIds,
            }),
        });

        // Log the response status and body for debugging
        const data = await response.json();

        if (!response.ok) {
            throw new Error('Failed to fetch brand URLs');
        }

        // Check if data is an array or if it contains a specific structure
        return data; // Modify based on the actual structure, e.g., `data.results` if needed
    } catch (error) {
        console.error('Error fetching brand URLs:', error);
        return null;
    }
}
